import { Injectable } from '@angular/core';
import { Balance, MerchantService } from '@galaxy/billing';
import { RetryConfig, retryer } from '@vendasta/rx-utils';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { ApiService } from '../../api-service/api.service';

const retryConfig: RetryConfig = {
  maxAttempts: 5,
  retryDelay: 200,
  timeoutMilliseconds: 10000,
};
@Injectable({ providedIn: 'root' })
export class BillingMetricsService {
  constructor(private apiService: ApiService, private merchantService: MerchantService) {}

  public saasMetrics(dateRange: string, groupByMarket = false): Observable<any> {
    const url = '/_ajax/v1/saas-metrics/';
    const body = {
      groupByMarket: groupByMarket,
      dateRange: dateRange,
    };
    return this.apiService.post(url, body);
  }

  public getOutstandingBalance(merchantId: string): Observable<Balance> {
    return this.merchantService.getOutstandingBalance(merchantId).pipe(retryer(retryConfig), shareReplay(1));
  }
}
